/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import * as v from "valibot"

import { nonBlankString } from "../../utils/non-blank-string"

// The API requires only the name; credentials remain required here to preserve
// the form's existing validation behavior after the migration.
export const OrganizationSchema = v.object({
    name: nonBlankString("Enter the organization name"),
    artifactoryUsername: nonBlankString("Enter the Artifactory login"),
    artifactoryPassword: nonBlankString("Enter the Artifactory password")
})
